<div  *ngIf="performanceModel?.accountProfile">
    <table style=  "width: 100%">
        <tr class="historical-volatility-header" aria-label="Historical volitility measure">
            <th scope="col" style="text-align:left">Settlement Date</th>
            <th scope="col"></th>
            </tr>
            <tr class="historical-volatility">
                <td scope="col" style="text-align:left">Purchases</td>
                <td scope="col">{{performanceModel?.accountProfile?.purchasesSettlementDate | DashIfEmpty }}</td>
               
            </tr>
            <tr class="historical-volatility">
                <td scope="col" style="text-align:left">Redemptions</td>
                <td scope="col">{{performanceModel?.accountProfile?.redemptionsSettlementDate| DashIfEmpty}}</td>
            </tr>

            <tr class="historical-volatility">
                <td scope="col" style="text-align:left">Note</td>
                <td scope="col">{{performanceModel?.accountProfile?.note| DashIfEmpty}}</td>
            </tr>
            </table>
</div>
<div *ngIf="!performanceModel?.accountProfile">
    <p class="rps-paragraph-one">Settlement Date</p>
    <p class="rps-paragraph-one">This information is temporarily unavailable.</p>
</div>